import React, {useCallback} from 'react';
import {Row} from 'reactstrap';
import {useCreation} from "ahooks";
import ItemSummaryCard from "src/components/item/ItemSummaryCard";
import Body from "src/components/layout/Body";
import {VirtualWindowDataResponse} from "src/model/VirtualWindowDataResponse";

export interface AlbumProps {
    data: VirtualWindowDataResponse,
    onItemSelected?: (itemUid: string) => {}
}

const Album = ({data, onItemSelected}: AlbumProps) => {

    const itemClickHandler = useCallback((uid) => {
        if (onItemSelected !== undefined) {
            onItemSelected(uid);
        }
    }, [onItemSelected]);

    const content = useCreation(() => {
        if (data === undefined || data.items === undefined) {
            return null;
        }
        return data.items.map((item, index) => <ItemSummaryCard key={`${item.uid}-${index}`} item={item} onClick={() => itemClickHandler(item.uid)}/>);
    }, [data])


    return (
        <Body>
            <Row className="p-0 m-0" style={{width: "100%", boxSizing: "border-box"}}>
                {content}
            </Row>
        </Body>
    );
}


export default Album;
